import * as React from 'react';
import { useSelector } from 'react-redux';

import { FavoriteEntity } from '../../components/FavoriteEntity';
import { selectOptions } from '../../selectors/print';
import { selectIsEntitySelected } from '../../selectors/selected';
import { IFavoriteEntity } from '../../types/results';
import { CheckboxContainer } from '../CheckboxContainer/CheckboxContainer';

export interface IProps {
  favoriteEntity: IFavoriteEntity;
  position: number;
  isEditComment: boolean;
  isFetchingComment: boolean;
  isSearcherOrSub: boolean;
}

export function FavoriteEntityContainer(props: IProps) {
  const { favoriteEntity } = props;
  const { entityId, entityType } = favoriteEntity;
  const isHideForPrint = useSelector(selectIsEntitySelected(entityId, entityType));
  const printOptions = useSelector(selectOptions);

  return (
    <FavoriteEntity
      {...props}
      isHideForPrint={!isHideForPrint}
      printComments={printOptions.printNotes}
      checkbox={<CheckboxContainer favoriteEntity={favoriteEntity} />}
    />
  );
}
